<div class="tab-pane" role="tabpanel" id="informe">
    <fieldset id="agregar_informe" class="">
        <div class="step_section">

            <div class="row" id="row">

                <div class="col-md-12" id="content">
                    <form [formGroup]="form">
                        <div class="form-horizontal">
                            <div class="form-group">
                                <div>
                                    <h3><strong>Reglamento de copropiedad</strong></h3>
                                </div>
                                <br>
                                <div class="col-md-12">
                                    <h4 class="col-md-3" align="left" style="padding-bottom: 10px; padding-top: 20px"><strong>Escritura P&uacute;blica</strong></h4>
                                    <div class="col-md-12">
                                        <label class="col-md-2" style=" padding-top: 15px; text-align:left"  for="infradio">Notar&iacute;a</label>
                                        <div class="col-md-10">
                                            <mat-form-field class="example-full-width" style="width: 145px;">
                                                <input matInput placeholder="Notaria" id="notaria_reg_copro" name="notaria_reg_copro" formControlName="notaria_reg_copro" (change)="add_reglamento_copropiedad()" [errorStateMatcher]="matcher">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <label class="col-md-2 control-label" style=" padding-top: 15px; text-align:left" for="fecha_notaria">Fecha</label>
                                        <div class="col-md-10">
                                            <mat-form-field style="width: 145px">
                                                <input matInput [matDatepicker]="dp3" [max]="maxDate" formControlName="fecha_notaria" (dateInput)="add_reglamento_copropiedad($event, 'input')" (dateChange)="add_reglamento_copropiedad($event, 'change')">
                                                <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
                                                <mat-datepicker #dp3 disabled="false"></mat-datepicker>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-md-12">
                                    <h4 class="col-md-12" align="left" style="padding-bottom: 10px; padding-top: 20px"><strong>Archivo</strong></h4>
                                    <br>
                                    <div class="col-md-12">
                                        <label class="col-md-2" align="left" style="padding-bottom: 10px; padding-top: 20px" for="infradio">C.B.R. de:</label>
                                        <div class="col-md-3">
                                            <mat-form-field class="example-full-width" style="width: 145px;">
                                                <input matInput placeholder="C.B.R" id="cbr_reg_copro" name="cbr_reg_copro" formControlName="cbr_reg_copro" (change)="add_reglamento_copropiedad()" [errorStateMatcher]="matcher">
                                            </mat-form-field>
                                        </div>
                                        <label class="col-md-2" align="left" style="padding-bottom: 10px; padding-top: 20px" for="infradio">Registro año:</label>
                                        <div class="col-md-4">
                                            <mat-form-field class="example-full-width" style="width: 145px;">
                                                <input matInput placeholder="año" id="registro_anio" name="registro_anio" formControlName="registro_anio" (change)="add_reglamento_copropiedad()" [errorStateMatcher]="matcher">
                                            </mat-form-field>
                                        </div>
                                        <label class="col-md-2" align="left" style="padding-bottom: 10px; padding-top: 20px" for="infradio">Fojas:</label>
                                        <div class="col-md-3">
                                            <mat-form-field class="example-full-width" style="width: 145px;">
                                                <input matInput placeholder="Fojas" id="fojas_reg_copro" name="fojas_reg_copro" formControlName="fojas_reg_copro" (change)="add_reglamento_copropiedad()" [errorStateMatcher]="matcher">
                                            </mat-form-field>
                                        </div>
                                        <label class="col-md-2" align="left" style="padding-bottom: 10px; padding-top: 20px" for="infradio">Numero:</label>
                                        <div class="col-md-4">
                                            <mat-form-field class="example-full-width" style="width: 145px;">
                                                <input matInput placeholder="Numero " id="numero" name="numero" formControlName="numero" (change)="add_reglamento_copropiedad()" [errorStateMatcher]="matcher">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </fieldset>
</div>
<div class="separator"></div>